import demo from  './demo.json';
import oto from  './oto.json';
import ph from  './ph.json';
import zwmy from  './zw-my.json';
import zwsg from  './zw-sg.json';
import fav from './fav.json';
import emp from './emp.json';
import triv from './triv.json';

const myExports = { demo, oto, ph, 'zw-my': zwmy, 'zw-sg': zwsg, fav, emp, triv };

export default myExports;

export const APPLICATION_STATUS = {
    UPDATE_INFO: 1,             
    DOCS_VERIFICATION: 2,         
    CREDIT_EVAL_CHECK: 3,       
    CREDIT_EVAL_GO_NO_GO: 4,   
    DVF_FORM: 5,
    HOME_SURVEY: 6,            
    REGULAR_ADDN_DOC: 7,       
    FINAL_EVALUATION: 8,        
    MEMO: 9,                 
    REJECTED: 10,              
    INCOMPLETE_APPLICATION: 11, 
};
export const SUB_STATUS = {
    RESUBMISSION: 1,
    REJECTED: 2,
    IN_PROCESS: 3,
    APPROVED: 4,
    INCOMPLETE_APPLICATION: 5,
    POSITIVE: 6,
    NEGATIVE: 7,
    EXPRESS_TO_REGULAR: 8,
    REGULAR_TO_EXPRESS: 9,
    Go:10,
    "No-Go":11
};

export const ROLE_MAPPING_SHOW_TEXT = {
    46: "Alpha",
    51: "RBH",
    52: "BM",
    53: "Agent",
    54: "BRO",
    56: "AM",
    57: "ARO",
    58: "ZM",
    59: "ARCO",
    60: "AMF"
}
// export default {demo,oto,ph,'zw-my':zwmy,'zw-sg':zwsg};//need to remove
